import styled from 'styled-components';
import {getColorFromTheme} from '@ui/ui-utils';

export const AllGoalsContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const GoalSections = styled.div`
  display: flex;
  flex-direction: column;
`;

export const GoalSection = styled.section`
  padding: 0 0 14px;
  border-bottom: 1px solid ${getColorFromTheme('borderLight')};

  & + & {
    padding-top: 14px;
  }

  &:last-child {
    border-bottom: 0;
  }
`;

export const GoalSectionHeader = styled.button`
  display: flex;
  width: fit-content;
  max-width: 100%;
  min-height: 52px;
  align-items: center;
  gap: 8px;
  padding: 4px;
  margin: -4px;
  border-radius: 8px;
  text-align: left;

  &:hover {
    background: ${getColorFromTheme('backgroundDark')};
  }

  &:focus-visible {
    outline: 2px solid ${getColorFromTheme('purple200')};
    outline-offset: 2px;
  }
`;

export const GoalSectionAvatar = styled.span`
  display: grid;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  place-items: center;
  border: 1px solid ${getColorFromTheme('white')};
  border-radius: 50%;
  background: ${getColorFromTheme('backgroundDark')};
  color: ${getColorFromTheme('blackTwo')};
  font: 500 13px/20px Graphik, sans-serif;
`;

export const GoalSectionIdentity = styled.span`
  min-width: 0;

  strong,
  small {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  strong {
    color: ${getColorFromTheme('blackTwo')};
    font: 600 14px/20px Graphik, sans-serif;
  }

  small {
    color: ${getColorFromTheme('textBody')};
    font: 400 13px/20px Graphik, sans-serif;
  }
`;

export const GoalSectionChevron = styled.span<{$expanded: boolean}>`
  display: grid;
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  place-items: center;
  margin-left: 2px;
  color: ${getColorFromTheme('textMuted')};

  svg {
    transition: transform 160ms ease;
    transform: rotate(${({$expanded}) => ($expanded ? '0deg' : '-90deg')});
  }
`;

export const GoalSectionCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
`;

export const FlatGoalCards = styled(GoalSectionCards)``;

export const PaginationBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 16px;
  color: ${getColorFromTheme('textBody')};
  font: 400 13px/20px Graphik, sans-serif;

  div {
    display: flex;
    gap: 8px;
  }

  button {
    min-height: 34px;
    padding: 6px 12px;
    border: 1px solid ${getColorFromTheme('borderDark')};
    border-radius: 8px;
    background: ${getColorFromTheme('white')};
    color: ${getColorFromTheme('textBody')};
    font: 500 13px/20px Graphik, sans-serif;

    &:hover:not(:disabled),
    &:focus-visible:not(:disabled) {
      outline: none;
      border-color: ${getColorFromTheme('purple300')};
      color: ${getColorFromTheme('purple300')};
    }

    &:disabled {
      border-color: ${getColorFromTheme('borderLight')};
      color: ${getColorFromTheme('textMuted')};
      cursor: not-allowed;
    }
  }

  @media (max-width: 520px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;
